import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=a4c1c0ae&scoped=true&"
import script from "./faq.vue?vue&type=script&lang=js&"
export * from "./faq.vue?vue&type=script&lang=js&"
import style0 from "./faq.vue?vue&type=style&index=0&id=a4c1c0ae&lang=scss&scoped=true&"
import style1 from "./faq.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c1c0ae",
  null
  
)

export default component.exports